<template>
	<div id="app">
		<router-view></router-view>
		<audio id="introMusic" preload="auto" src="/static/audio/intro.mp3" loop="loop"></audio>
		<audio id="gamingMusic" preload="auto" src="/static/audio/gaming.mp3" loop="loop"></audio>
		<audio id="gamingMusicB" preload="auto" src="/static/audio/gamingBride.mp3" loop="loop"></audio>
		<audio id="endingMusic" preload="auto" src="/static/audio/ending.mp3" loop="loop"></audio>
		<audio id="catchMusic" preload="auto" src="/static/audio/catch.mp3"></audio>
		<audio id="powerUpMusic" preload="auto" src="/static/audio/powerUp.mp3"></audio>
		<audio id="selectMusic" preload="auto" src="/static/audio/select.mp3"></audio>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'
	export default {
		name: 'app',
		methods: {
			...mapActions([
				'setDevice'
			]),
		},
		computed: {
			...mapGetters({
				device: 'isMobile'
			})
		},
		mounted () {
			this.setDevice(window.mobileAndTabletcheck());
		}
	}
</script>


// WEBPACK FOOTER //
// App.vue?90f2022a